// extracted by mini-css-extract-plugin
module.exports = {"IconLink":"IconLink_IconLink__3asrc","link":"IconLink_link__1wpye"};